var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2656 15.5031V15.7375H17.5H18.5156V16.5187H1.48438V15.7375H2.5H2.73438V15.5031V14.2533C2.73706 12.4324 3.42278 10.6788 4.65598 9.3391C5.88922 7.99935 7.58022 7.17104 9.39471 7.01791L9.60938 6.99979V6.78436V5.50311V5.26874H9.375H7.73438V4.48749H12.2656V5.26874H10.625H10.3906V5.50311V6.78436V6.99979L10.6053 7.01791C12.4198 7.17104 14.1108 7.99935 15.344 9.3391C16.5773 10.6788 17.263 12.4325 17.2656 14.2535V15.5031ZM10.0003 7.76874L9.99968 7.76874C8.50569 7.7708 7.05809 8.28784 5.90086 9.23272C4.74362 10.1776 3.9475 11.4925 3.64668 12.9559L3.58879 13.2375H3.87625H16.1238H16.4112L16.3533 12.9559C16.0525 11.4925 15.2564 10.1776 14.0991 9.23272C12.9419 8.28784 11.4943 7.7708 10.0003 7.76874ZM3.75 14.0187H3.51562V14.2531V15.5031V15.7375H3.75H16.25H16.4844V15.5031V14.2531V14.0187H16.25H3.75Z",
    fill: "#8D8C8C",
    stroke: "#58B6A8",
    strokeWidth: 0.46875
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.19d4c4e3.svg";
export { ForwardRef as ReactComponent };